var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { HomePage, HostPage } from "./pages";
import { EngageContext, ErrorType } from "./context";
import JoinPage from "./pages/join";
import AdminPage from "./pages/admin";
import { isUndefined } from "engage-common/utils";
import UserLimitPage from "./pages/userlimit";
import { ThemeDefinitions } from "./theme";
import { ThemeProvider } from "react-jss";
var EngageRouter = function (props) {
    var _a, _b;
    var _c = useContext(EngageContext), user = _c.user, lobby = _c.lobby, lobbyValidation = _c.lobbyValidation;
    var AppComponent = user && lobby && props.roleComponents[user.role];
    return (React.createElement(ThemeProvider, { theme: (_b = (_a = ThemeDefinitions[lobby === null || lobby === void 0 ? void 0 : lobby.themeId]) !== null && _a !== void 0 ? _a : ThemeDefinitions[lobbyValidation === null || lobbyValidation === void 0 ? void 0 : lobbyValidation.themeId]) !== null && _b !== void 0 ? _b : ThemeDefinitions.brand2025 },
        React.createElement(BrowserRouter, null,
            props.addtlComponents,
            React.createElement(Routes, null,
                props.overrideRoutes && Object.entries(props.overrideRoutes).map(function (_a, index) {
                    var route = _a[0], component = _a[1];
                    return React.createElement(Route, { key: index, path: route }, component);
                }),
                React.createElement(Route, { path: "/userlimit" },
                    React.createElement(UserLimitPage, null)),
                React.createElement(CheckedRoute, { path: "/host" },
                    React.createElement(HostPage, { createLobbyExtension: props.createLobbyExtension })),
                React.createElement(CheckedRoute, { path: "/j/:lobbyID" },
                    React.createElement(JoinPage, null)),
                React.createElement(Route, { path: "/admin" },
                    React.createElement(AdminPage, null)),
                React.createElement(Route, { path: "/app" }, AppComponent ? React.createElement(AppComponent, null) : React.createElement(Navigate, { to: "/" })),
                React.createElement(CheckedRoute, { path: "/" },
                    React.createElement(HomePage, null))))));
};
export default EngageRouter;
var CheckedRoute = function (props) {
    var _a = useContext(EngageContext), user = _a.user, lobby = _a.lobby, errorMap = _a.errorMap;
    var children = props.children, other = __rest(props, ["children"]);
    var navigate = useNavigate();
    useEffect(function () {
        if (errorMap && !isUndefined(errorMap[ErrorType.Rejected])) {
            navigate("/userlimit");
        }
        else if (!isUndefined(user) && !isUndefined(lobby)) {
            navigate("/app");
        }
    }, [errorMap, user, lobby]);
    return (React.createElement(Route, __assign({}, other), children));
};
//# sourceMappingURL=router.js.map